export const FIELD_LABEL = 0;
export const FIELD_NAME = 1;
export const FIELD_TYPE = 2;
export const FIELD_WIDTH = 3;
export const FIELD_CONFIG = 4;


// WEBPACK FOOTER //
// ./client/components/auto/constants.js